import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if the user has already consented to cookies
    const consent = Cookies.get("cookie-consent");
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set("cookie-consent", "true", { expires: 30, path: "/" });
    setShowConsent(false);
  };

  const handleDecline = () => {
    setShowConsent(false);
  };

  return (
    showConsent && (
      <div
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent overlay
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: "9999",
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            color: "#333",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            textAlign: "center",
            width: "50%",
            justifyItems: "center",
          }}
        >
          <h3>Cookie Consent</h3>
          <p
            style={{
              marginTop: 20,
              marginBottom: 20,
            }}
          >
            We use essential cookies to ensure you have the best experience on
            our website. Please let us know if you consent to the use of
            cookies.
          </p>
          <div>
            <button
              onClick={handleAccept}
              style={{
                backgroundColor: "#7FBEB3",
                color: "#000",
                padding: "10px 20px",
                border: "none",
                cursor: "pointer",
                borderRadius: "5px",
                margin: "10px",
              }}
            >
              Accept
            </button>
            <button
              onClick={handleDecline}
              style={{
                backgroundColor: "#000",
                color: "#fff",
                padding: "10px 20px",
                border: "none",
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              Decline
            </button>
          </div>
        </div>
      </div>
    )
  );
}

export default CookieConsent;
